module.exports = __webpack_public_path__ + "img/train-6.96b73510.jpg";